import React, { Component } from "react";

class MilesCalculator extends Component {
  render() {
    const miles = this.props.price * this.props.multiplier;
    console.log(this.props);
    let totalMiles = miles;

    totalMiles = Math.round(totalMiles * 100 / 100);

    if (isNaN(totalMiles) || totalMiles < 0) {
      totalMiles = "N/A";
    }

    return (
      <div className="CellDisplay">
        {totalMiles}
      </div>
    );
  }
}

export default MilesCalculator;



// WEBPACK FOOTER //
// ./src/MilesCalculator.js